import request from "@/utils/request";

//企业规模类型测评
export function enterpriseSizeEva(data) {
  return request({
    url: "/entSizeAndTechEva/enterpriseSizeEva",
    method: "post",
    data,
  });
}

//科技型中小企业测评
export function enterpriseTechEva(data) {
  return request({
    url: "/entSizeAndTechEva/enterpriseTechEva",
    method: "post",
    data,
  });
}

//根据企业规模查询政策列表
export function listByEntSize(params) {
  return request({
    url: "/policy/listByEntSize",
    method: "get",
    params,
  });
}

//查询符合科技型中小企业条件的政策列表
export function listByTechBasesSmes(params) {
  return request({
    url: "/policy/listByTechBasesSmes",
    method: "get",
    params,
  });
}